<template>
  <v-form
      autocomplete="off"
      v-model="valid"
      ref="formJob"
      class="auth-form"
      @submit.prevent="Submit"
      :disabled="!editable"
  >
    <div class="auth-form--wrap d-flex flex-wrap justify-space-between">

      <div class="auth-form--wrap-col w50">
        <div class="input-label">Название</div>
        <v-text-field
            type="text"
            v-model="form.title"
            placeholder="Название объекта"
            :rules="[rules.required]"
            outlined
            dense
            required
        />
      </div>
      <div class="auth-form--wrap-col w50">
        <div class="input-label">Тип</div>
        <v-select
            :items="types"
            v-model="form.type_id"
            :loading="loading"
            no-data-text="Загрузка..."
            :rules="[rules.required]"
            outlined
            dense
            required
            item-text="title"
            item-value="id"
        />
      </div>
      <div class="auth-form--wrap-col w-100 mb-5">
        <div class="input-label">Ближайший город</div>
        <v-autocomplete
            v-model="form.city_id"
            :items="cities"
            :search-input.sync="searchCity"
            :loading="loading"
            :clearable="true"
            :open-on-clear="true"
            hide-details
            hide-no-data
            class="plcolor custom-autocomplete"
            :rules="[rules.required]"
            required
            item-text="title"
            item-value="id"
            dense
            solo
        />
      </div>
      <div class="auth-form--wrap-col w-100 mb-5">
        <div class="input-label">Адрес</div>
        <v-autocomplete
            v-model="form.address"
            :items="addresses"
            :search-input.sync="searchAddress"
            placeholder="Начните вводить адрес"
            :loading="loading"
            :filter="() => true"
            :clearable="true"
            :open-on-clear="true"
            hide-details
            hide-no-data
            class="plcolor custom-autocomplete"
            :rules="[rules.required]"
            required
            item-text="value"
            item-value="value"
            dense
            solo
        />
      </div>

      <div class="add-files auth-form--wrap-col w-100">
        <div class="input-label">Добавление файлов</div>
        <div class="add-files--button">
          <div class="add-files--button-text">Минимум 4, максимум {{ maxFilesLength }} изображений. Формат – JPG, PNG,
            TIFF или BMP. Размер – не более {{ maxFileSize }} МБ.<br/>Рекомендуемое разрешение – не менее 720 x 720
            пикс. и
            не более 3000 x 3000 пикс.
          </div>
        </div>
        <div class="add-files--list">
          <div class="add-files--photos">
            <div class="add-files--photo" v-if="form.photos.length" v-for="(f, key) in form.photos" :key="key">
              <v-avatar class="add-files--image-wrap" tile size="72" @click="showImage(f.url || f.base64)">
                <img class="add-files--image" :src="f.url || f.base64" alt="image"/>
              </v-avatar>
              <i v-if="editable" @click="deleteImage(key)" class="add-files--image-delete">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
                      fill="#D60000"/>
                  <path
                      d="M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z"
                      fill="white"/>
                </svg>
              </i>
            </div>
            <div class="add-files--photo" v-if="form.photos.length < maxFilesLength">
              <div class="auth-form--wrap add-photo">
                <v-file-input
                    multiple
                    class="mt-0 pt-0"
                    accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-camera-plus-outline"
                    @change="TransformFile"
                    :rules="[rules.maxFiles, rules.minFiles]"
                    :hide-input="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="auth-form--wrap-col w-100">
        <div class="input-label">Описание</div>
        <v-textarea
            v-model="form.description"
            filled
            outlined
            dense
            hide-details
            class="mb-4"
        />
      </div>
      <div class="auth-form--wrap with-chbox flex-wrap justify-space-between w-100">
        <div class="card-checkbox">
          <v-checkbox v-model="form.is_visible" hide-details class="mt-0">
            <template v-slot:label>
              <div class="input-label">
                <span class="font-weight-black">Публичная работа</span>
                <span class="color-grey">Данная работа будет доступна для просмотра заказчикам</span>
              </div>
            </template>
          </v-checkbox>
        </div>
        <v-btn
            v-if="editable"
            type="submit"
            color="primary"
            class="btn-blue mb-0"
            :disabled="jobLoading"
        >Сохранить
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import axios from 'axios';

// const defaultImage = { base64: '', name: '', filename: '', url: '' };

export default {
  name: 'JobForm',
  props: ['item', 'editable'],
  data() {
    return {
      addresses: [],
      cities: [],
      searchCity: '',
      searchAddress: '',
      selectedAddress: null,
      valid: false,
      maxFileSize: 5, // Mbt
      maxFilesLength: 15,
      minFilesLength: 4,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        maxFiles: () => this.form.photos.length < this.maxFilesLength || `Количество файлов не более ${this.maxFilesLength}`,
        minFiles: () => this.form.photos.length >= this.minFilesLength || `Количество файлов не менее ${this.minFilesLength}`,
      },
      form: {
        id: null,
        title: '',
        is_visible: true,
        address: '',
        city_id: null,
        type_id: null,
        description: '',
        photos: [],
      },

    };
  },
  watch: {

    /** Вотчер для автокомплита адресов */
    searchAddress(query) {
      if (query) {
        const app = this;
        const info = { count: 20, query };
        const config = {
          headers: {
            Accept: 'application/json, text/javascript, */*; q=0.01',
            Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
            'Content-Type': 'application/json',
          },
        };

        axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
          .then((res) => {
            app.addresses = res.data.suggestions;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (val) {
        this.$store.getters.axl
          .post('location/api/cities/list', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
    item() {
      this.prepareItem();
    },
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    jobLoading() {
      return this.$store.state.jobs.loading;
    },
    types() {
      return this.$store.state.jobs.types || [];
    },
    maxSize() {
      if (this.form.photos.length) {
        return this.form.photos.reduce((acc, f) => acc + (f.size || 0), 0) < (this.maxFileSize * 1000000) || `Размер файлов больше ${this.maxFileSize}Мбт`;
      }
      return '';
    },
  },
  methods: {
    showImage(image) {
      const img = document.createElement('img');
      const div = document.createElement('div');
      div.classList.add('image-container');
      div.id = 'div';
      img.classList.add('image-container--img');
      img.src = image;
      div.appendChild(img);
      document.body.appendChild(div);
      img.addEventListener('click', () => {
        const divToRemove = document.getElementById('div');
        document.body.removeChild(divToRemove);
      });
    },
    deleteImage(idx) {
      this.form.photos.splice(idx, 1);
    },
    /** Методы для работы с документами */
    async TransformFile(files, idx) {
      const app = this;
      const file = files[0];
      const document = { file: '', url: '', name: '' };
      if (!file || file.name.lastIndexOf('.') <= 0) {
        return document;
      }
      const fr = new FileReader();
      await fr.readAsDataURL(file);
      await fr.addEventListener('load', () => {
        document.name = file.name;
        document.file = null;
        document.base64 = fr.result;
        document.key = `${idx}_${Date.now()}`;
        app.form.photos.push(document);
      });
      return document;
    },
    ChangeAddress(e) {
      this.form.address = e.value;
    },
    Submit() {
      if (this.$refs.formJob.validate()) {
        this.$store.state.jobs.loading = true;
        this.$emit('save', { ...this.form });
      }
    },

    prepareItem() {
      if (this.item) {
        const initForm = {
          id: null,
          title: '',
          is_visible: true,
          address: '',
          city_id: null,
          type_id: null,
          description: '',
          photos: [],
        };
        this.form = { ...initForm, ...this.item };
        if (this.item.city) {
          this.cities = [this.item.city];
        }
        if (this.item.address) {
          this.addresses = [{ value: this.item.address, data: {} }];
        }
      }
    },
  },
  mounted() {
    this.$store.state.jobs.loading = false;
    this.$store.dispatch('jobs/GetTypes');
    this.prepareItem();
  },
};
</script>

<style lang="scss" scoped>
.add-files {
  margin-bottom: 15px;

  &--button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    &-text {
      font-size: 12px;
    }

    @media (max-width: 600px) {
      flex-direction: column-reverse;
      align-items: flex-start;
      &-text {
        padding-bottom: 15px;
        padding-left: 0;
      }
    }
  }

  &--list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
    border: 2px dashed #E6E8F0;
    border-radius: 8px;

    .add-photo {
      margin: 15px 30px 15px 0;
    }
  }

  &--photos {
    display: flex;
    flex-wrap: wrap;
  }

  &--photo {
    position: relative;
  }

  &--image-wrap {
    margin: 15px 15px 15px 0;
  }

  &--image {
    border-radius: 8px !important;
  }

  &--image-delete {
    position: absolute;
    top: 2px;
    right: 2px;
    height: 28px;
  }
  &--image-delete:hover {
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #00000066;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  &--img {
    height: 50%;
    &:hover {
      cursor: zoom-out;
    }
  }
}
</style>
